import React, { ReactElement, useEffect } from 'react';

import SemiStore from '@/stores/semi';

import logPrice from './log-price';

export default function SemiInfo({
  indexSelected,
  children,
  priceListWithLadderLogistic,
  productId,
  defaultLogisticsList,
}: {
  indexSelected: number;
  productId: number;
  priceListWithLadderLogistic: PriceTypes.PriceListWithLadderLogistic;
  defaultLogisticsList: PriceTypes.ShippingType[];
  children: ReactElement<any, any>;
}) {
  const { logisticsList } = SemiStore(state => state);
  const expressKey =
    logisticsList[indexSelected]?.defaultLogistics || defaultLogisticsList[indexSelected];
  const priceInfo = priceListWithLadderLogistic[indexSelected][expressKey];

  useEffect(() => {
    logPrice(
      '/sc.detail_pc_halfdelegated_price',
      priceInfo,
      'EXP',
      `is_default_quality=false&productId=${productId}`
    );
  }, [priceInfo]);

  const renderOriginalPrice = (originalPrice: string) => {
    if (originalPrice) return <del>{originalPrice}</del>;
    return null;
  };

  return (
    <div className="price-info">
      {children}
      {priceInfo.noShipping && (
        <div
          className="no-shipping"
          dangerouslySetInnerHTML={{
            __html: priceInfo.noShipping.priceBeforeShippingText,
          }}
        ></div>
      )}
      <div className="price">
        <strong>{priceInfo.formatTotalPrice}</strong>{' '}
        {renderOriginalPrice(priceInfo.formatOriginalTotalPrice)} {priceInfo.totalPriceUnitText}
      </div>
      <div className="info">
        {!priceInfo.noShipping && <div className="hd">{priceInfo.includeText}</div>}
        {!priceInfo.noShipping && (
          <div className="item">
            <strong>{priceInfo.formatProductPrice}</strong>{' '}
            {renderOriginalPrice(priceInfo.formatOriginalProductPrice)} {priceInfo.productPriceText}
          </div>
        )}
        {priceInfo.noShipping ? (
          <div className="item shipping">{priceInfo.noShipping.contactSupplierText}</div>
        ) : (
          <div className="item">
            <strong>{priceInfo.formatShippingPrice}</strong>{' '}
            {renderOriginalPrice(priceInfo.formatOriginalShippingPrice)}{' '}
            {priceInfo.shippingPriceText}
          </div>
        )}
      </div>
    </div>
  );
}
